"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@headlessui/react");
const classnames_1 = __importDefault(require("classnames"));
const Toggle = ({ enabled, onToggle, label }) => {
    const onChange = (value) => {
        onToggle(value);
    };
    return (react_1.default.createElement(react_2.Switch.Group, { as: "div", className: "flex items-center" },
        react_1.default.createElement(react_2.Switch, { checked: enabled, onChange: onChange, className: (0, classnames_1.default)(enabled ? 'bg-primary-500' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2') },
            react_1.default.createElement("span", { className: "sr-only" }, "Use setting"),
            react_1.default.createElement("span", { "aria-hidden": "true", className: (0, classnames_1.default)(enabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out') })),
        react_1.default.createElement(react_2.Switch.Label, { as: "span", className: "ml-3 text-sm cursor-pointer" },
            react_1.default.createElement("span", { className: "font-medium text-gray-900" }, label),
            ' ')));
};
exports.default = Toggle;
